import React, { useEffect, useState } from 'react';
export const ScrollButton = ({
  children,
  className,
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  const scrollToCheckout = (behavior: ScrollBehavior) => {
    document.getElementById('precio')?.scrollIntoView({
      behavior,
      block: 'start'
    });
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onClick?.();
    window.dispatchEvent(new Event('pilates360:prepare-checkout'));
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        scrollToCheckout('smooth');
      });
    });
    window.setTimeout(() => scrollToCheckout('auto'), 600);
  };
  return <button type="button" onClick={handleClick} className={className} aria-controls="precio" data-id="element-242" data-mp="pg8yleck9425">
      {children}
    </button>;
};
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 37);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center gap-2 text-3xl md:text-4xl font-serif font-bold text-brand-terracotta justify-center" data-id="element-243" data-mp="2vjgf5apofmfa">
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-244" data-mp="2qmgc78o4izse">
        {hours.toString().padStart(2, '0')}
      </div>
      <span className="text-brand-charcoal" data-id="element-245" data-mp="2gw555d958aha">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-246" data-mp="2ctqngwh7ngrl">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-brand-charcoal" data-id="element-247" data-mp="27tvtgk252b2b">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-248" data-mp="22vau0mupnvex">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
};
const names = ['María P.', 'Lucía F.', 'Sofía G.', 'Martín R.', 'Federico A.', 'Carolina M.', 'Diego S.', 'Valentina T.', 'Florencia B.', 'Camila V.', 'Agustín C.', 'Matías L.', 'Julieta N.', 'Micaela D.', 'Gonzalo H.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Santa Fe', 'Posadas', 'Resistencia', 'Corrientes'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    let hideTimer: number | undefined;
    const showPopup = () => {
      setData({
        name: names[Math.floor(Math.random() * names.length)],
        city: cities[Math.floor(Math.random() * cities.length)],
        time: Math.floor(Math.random() * 45) + 1
      });
      setIsVisible(true);
      hideTimer = window.setTimeout(() => setIsVisible(false), 6000);
    };
    const initialTimer = window.setTimeout(showPopup, 5000);
    const interval = window.setInterval(showPopup, 30000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-brand-sand p-4 max-w-xs md:max-w-sm flex gap-4 items-start transition-all duration-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} aria-live="polite" data-id="element-249" data-mp="5aplp4cwizha">
      <div className="bg-brand-terracotta/10 p-2.5 rounded-full text-brand-terracotta flex-shrink-0" data-id="element-250" data-mp="a7z9kfkn7330">
        📍
      </div>
      <div className="flex-1 pt-0.5" data-id="element-251" data-mp="1lofugoeyubx9">
        <p className="text-sm text-brand-charcoal leading-snug" data-id="element-252" data-mp="1lne65i8xvsxl">
          <span className="font-bold block text-base mb-0.5" data-id="element-253" data-mp="2gyvt7qfub2sp">{data.name}</span>
          de {data.city} acaba de comprar PILATES 360 hace {data.time} minutos.
        </p>
      </div>
      <button type="button" onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 flex-shrink-0" aria-label="Cerrar notificación" data-id="element-254" data-mp="2l20u5ok9uwf8">
        ×
      </button>
    </div>;
};